import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Utils } from 'formiojs';

@Pipe({
  name: 'cssClassDisplay',
})
export class CssClassDisplayPipe implements PipeTransform {
  constructor(private translateService: TranslateService) { }

  transform(resourceItem: any, optionClass): string {
    if (typeof resourceItem === 'string' || !resourceItem) {
      return null;
    }
    return Utils.evaluate(`${optionClass}`, {
			item: resourceItem,
			translate: this.translateService,
		});
  }
}